import PersonIcon from "@mui/icons-material/Person";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SchoolIcon from "@mui/icons-material/School";
import FavoriteIcon from "@mui/icons-material/Favorite";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import QuizIcon from "@mui/icons-material/Quiz";
import MessageIcon from "@mui/icons-material/Message";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import GroupIcon from "@mui/icons-material/Group";
import FeedbackIcon from "@mui/icons-material/Feedback";
import PaymentsIcon from "@mui/icons-material/Payments";
import NotificationIcon from "@mui/icons-material/Notifications";
import PurchasesHistoryIcon from "@mui/icons-material/History";
export const roleMenus: any = {
  student: [
    {
      items: [
        { label: "My Learning", route: "/learning", icon: SchoolIcon },
        { label: "Wishlist", route: "/wishlist", icon: FavoriteIcon },
        { label: "My Cart", route: "/cart", icon: FavoriteIcon },
        {
          label: "Dashboard",
          route: "/student-dashboard",
          icon: DashboardIcon,
        },
        {
          label: "Purchases History",
          route: "/purchases-history",
          icon: PurchasesHistoryIcon,
        },

        { label: "Message", route: "/message", icon: MessageIcon },
        {
          label: "Notification",
          route: "/notification",
          icon: NotificationIcon,
        },

        { label: "My Profile", route: "/profile", icon: PersonIcon },
        { label: "Settings", route: "/setting", icon: SettingsIcon },
        { label: "Log Out", route: "/auth", icon: LogoutIcon },
      ],
    },
  ],

  teacher: [
    {
      items: [
        { label: "Create Course", route: "/course-info", icon: MenuBookIcon },
        {
          label: "Question Paper",
          route: "/question-form",
          icon: QuizIcon,
        },
        {
          label: "Dashboard",
          route: "/teacher-dashboard",
          icon: DashboardIcon,
        },

        { label: "Message", route: "/message", icon: MessageIcon },
        {
          label: "Notification",
          route: "/notification",
          icon: NotificationIcon,
        },

        { label: "My Profile", route: "/profile", icon: PersonIcon },
        { label: "Settings", route: "/setting", icon: SettingsIcon },
        { label: "Log Out", route: "/auth", icon: LogoutIcon },
      ],
    },
  ],

  instructor: [
    {
      items: [
        { label: "Create Course", route: "/course-info", icon: MenuBookIcon },
        {
          label: "Question Paper",
          route: "/question-course-info",
          icon: QuizIcon,
        },
        {
          label: "Dashboard",
          route: "/teacher-dashboard",
          icon: DashboardIcon,
        },

        { label: "Message", route: "/message", icon: MessageIcon },
        {
          label: "Notification",
          route: "/notification",
          icon: NotificationIcon,
        },

        { label: "My Profile", route: "/profile", icon: PersonIcon },
        { label: "Settings", route: "/setting", icon: SettingsIcon },
        { label: "Log Out", route: "/auth", icon: LogoutIcon },
      ],
    },
  ],

  parent: [
    {
      items: [
        {
          label: "Parent Dashboard",
          route: "/parent-profile",
          icon: DashboardIcon,
        },
        {
          label: "Child Progress",
          route: "/child-progress",
          icon: TrendingUpIcon,
        },
        { label: "Message", route: "/message", icon: MessageIcon },
        {
          label: "Notification",
          route: "/notification",
          icon: NotificationIcon,
        },

        { label: "My Profile", route: "/profile", icon: PersonIcon },
        { label: "Settings", route: "/setting", icon: SettingsIcon },
        { label: "Log Out", route: "/auth", icon: LogoutIcon },
      ],
    },
  ],

  admin: [
    {
      items: [
        { label: "Admin Home", route: "/home-admin", icon: DashboardIcon },
        { label: "Students", route: "/students-admin", icon: GroupIcon },
        { label: "Teachers", route: "/teacher-admin", icon: SchoolIcon },
        { label: "Courses", route: "/courses-admin", icon: MenuBookIcon },
        { label: "Feedback", route: "/feedback-admin", icon: FeedbackIcon },
        { label: "Billing", route: "/billing-admin", icon: PaymentsIcon },
        { label: "Settings", route: "/setting", icon: SettingsIcon },
        { label: "Log Out", route: "/auth", icon: LogoutIcon },
      ],
    },
  ],
};
